import { makeStyles } from '@material-ui/core/styles'
import { VIDEO_VISIT_REARRANGEMENT } from 'constants/breakpoints'

// @ts-ignore
const useStyles = makeStyles((theme) => {
  // @ts-ignore
  const tertiary = theme.palette.tertiary

  return {
    root: {
      borderRadius: '5em',
      padding: '0.7em',
      display: 'inline-flex',
      cursor: 'pointer',
      [theme.breakpoints.down(1030)]: {
        padding: '0.45em',
      },
      [theme.breakpoints.down(930)]: {
        padding: '0.4em',
      },
      [theme.breakpoints.down(VIDEO_VISIT_REARRANGEMENT)]: {
        padding: '0.8em',
      },
    },
    offset: {
      margin: '0.5em',
    },
    badgeBg: {
      background: tertiary.red,
      color: '#fff',
    },

    icon: {
      width: '1.2em',
      height: '1.2em',
      boxSizing: 'padding-box',
      color: '#fff',
      fill: '#fff',
      '& path': {
        fill: 'currentColor',
      },

      [theme.breakpoints.down(930)]: {
        width: '1.8em',
        height: '1.8em',
      },
    },
    video: {
      background: tertiary.brightGreen,
    },
    audio: {
      background: tertiary.orange,
    },
    hangup: {
      background: tertiary.red,
    },
    chat: {
      background: tertiary.lightBlue,
    },
    settings: {
      background: tertiary.lightGrey,
    },
  }
})

export default useStyles
